import React, { FC } from 'react';
import { CheckboxProps as MuiCheckBoxProps, Checkbox as MuiCheckBox } from '@mui/material';

interface CheckBoxProps extends MuiCheckBoxProps { }

const CheckBox: FC<CheckBoxProps> = ({ sx = [], ...props }) => (
  <MuiCheckBox sx={[
    {
      backgroundColor: 'white',
      "&.Mui-checked": {
        color: "#3D4449"
      }
    },
    ...(Array.isArray(sx) ? sx : [])
  ]} {...props} />
);

export default CheckBox;
